import clsx from 'clsx';

import type { FC, HTMLAttributes } from 'react';

import s from './GroupFooter.module.css';

type GroupFooterProps = HTMLAttributes<HTMLDivElement>;

const GroupFooter: FC<GroupFooterProps> = ({ className, ...props }) => (
  <div className={clsx(s.footer, className)} {...props} />
);

export { GroupFooter };
